export default {
  data() {
    return {
      // mixTipoRetencion: 'baseDias',
      // mixPorcentajeRentencion: 0.005,
    };
  },
  methods: {
    mixCalcularRetencion() {
      if (this.mixTipoRetencion === 'baseDias') {
        this.mixCalcularRetencionBaseDias();
      } else {
        this.mixCalcularRetencionBaseMonto();
      }
    },
    mixCalcularRetencionBaseMonto() {
      const importeProgramado = this.importeProgramadoActual.importe;
      const importeRetrazoActual = (importeProgramado - this.importeEstimadoActual)
      * this.mixPorcentajeRentencion;
      const importeAunRetenido = this.importeRetenidoAnterior - this.importeDevueltoAnterior;

      // Determinar si la retienes o la devuelves
      if (importeRetrazoActual <= importeAunRetenido) {
        // En caseo de que la retencion sea meno o igual,
        // A lo retenido anterior restarle lo retenido a este estimacion
        this.estimacion.importeDevuelto = importeAunRetenido - importeRetrazoActual;
      } else {
        // En caso de que la retencion sea mayor a lo retenido anterior
        // enconces a la retencion actual le restamos lo retenido anterior
        this.estimacion.importeRetenido = this.$numberRound(
          importeRetrazoActual - importeAunRetenido,
        );
      }
    },
    mixCalcularRetencionBaseDias() {
      const { importe: importeProgramado, diasTranscuridos } = this.importeProgramadoActual;
      const importeDiarioProgramado = this.$numberRoundDigits(
        importeProgramado / diasTranscuridos,
        2,
      );
      const montoEjecutado = this.importeEstimadoActual;
      // Los dias ejecutado reales, se ajusta al entero inferiro
      let diasEjecutadosConRelacionAlMontoDiario = 0;
      if (this.mixRedondearHaciaArriba) {
        diasEjecutadosConRelacionAlMontoDiario = Math.ceil(
          montoEjecutado / importeDiarioProgramado,
        );
      } else {
        diasEjecutadosConRelacionAlMontoDiario = Math.floor(
          montoEjecutado / importeDiarioProgramado,
        );
      }

      const diasDesfazamiento = diasTranscuridos - diasEjecutadosConRelacionAlMontoDiario;

      // Calcular importe de atraso
      const importeAtraso = this.$numberRoundDigits(diasDesfazamiento * importeDiarioProgramado, 2);
      // Calcular retencion
      let importeRetencion = 0;
      if (!this.mixEsRetencionPorDia) {
        importeRetencion = this.$numberRoundDigits(
          importeAtraso * this.mixPorcentajeRentencion,
          2,
        );
      } else {
        importeRetencion = this.$numberRoundDigits(
          (importeAtraso * this.mixPorcentajeRentencion) * diasDesfazamiento,
          2,
        );
      }
      const importeAunRetenido = this.$numberRoundDigits(
        this.importeRetenidoAnterior - this.importeDevueltoAnterior,
        2,
      );

      // Checar si es la estimacion finiquito
      if (this.estimacion.esEstimacionFiniquito) {
        importeRetencion = 0;
      }

      // Determinar si la retienes o la devuelves
      if (importeRetencion <= importeAunRetenido) {
        // En caseo de que la retencion sea meno o igual,
        // A lo retenido anterior restarle lo retenido a este estimacion
        this.estimacion.importeDevuelto = importeAunRetenido - importeRetencion;
      } else {
        // En caso de que la retencion sea mayor a lo retenido anterior
        // enconces a la retencion actual le restamos lo retenido anterior
        this.estimacion.importeRetenido = this.$numberRound(importeRetencion - importeAunRetenido);
      }
    },
  },
  computed: {
    mixEsRetencionPorDia() {
      if (!this.contrato) return false;

      return this.contrato.esRetencionPorDia || false;
    },
    mixRedondearHaciaArriba() {
      if (!this.contrato) return false;

      return this.contrato.redondearMasDiasEjecutados || false;
    },
    mixTipoRetencion() {
      if (!this.contrato) return 'baseDias';
      if (!this.contrato.tipoRetencion) return 'baseDias';

      return this.contrato.tipoRetencion;
    },
    mixPorcentajeRentencion() {
      if (!this.contrato) return 0.005;
      if (!this.contrato.porcentajeRetencion) return 0.005;

      return (this.contrato.porcentajeRetencion / 100);
    },
  },
};
